module.exports = __webpack_public_path__ + "static/media/sopt4kz.88c6fb21.pdf";